import React, { useContext, useEffect } from 'react';
import { Box, Container } from '@chakra-ui/react';
import Navbar from '../compnents/Navbar';
import Footer from '../compnents/Footer';
import HeroSection from '../compnents/landingComponents/HeroSection';
import WhyFinansee from '../compnents/landingComponents/WhyFinansee';
import HowItWorks from '../compnents/landingComponents/HowItWorks';
import AuthContext from '../context/AuthContext';
import ThemeContext from '../context/ThemeContext';
import { useNavigate } from 'react-router-dom';

const LandingPage = () => {
  const { token } = useContext(AuthContext);
  const { themeData } = useContext(ThemeContext);
  const navigate = useNavigate();

  // Extract theme colors with fallbacks
  const backgroundColor = themeData?.colors?.background || '#F7FAFC';

  useEffect(() => {
    if (token) {
      navigate("/dashboard");
    }
  }, [token, navigate]);

  return (
    <Box minH="100vh" display="flex" flexDirection="column" bg={backgroundColor}>
      <Navbar />

      <Container maxW="container.xl" flex="1">
        <HeroSection />
        <WhyFinansee />
        <HowItWorks />
      </Container>
      <Footer />
    </Box>
  );
};

export default LandingPage;